module.exports = __webpack_public_path__ + "static/media/IconPlusWhite.92276dba.svg";